import { useEffect, useState } from 'react';

const useUserAgent = (): string => {
  const [userAgent, setUserAgent] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setUserAgent(window?.navigator.userAgent);
    }
  }, []);
  return userAgent;
};

export default useUserAgent;
